// businessCategories.js

// Array of business categories in alphabetical order
const categories = [
    "Appliances",
    "Arts & Crafts",
    "Automotive",
    "Baby Products",
    "Beauty & Personal Care",
    "Books",
    "Clothing & Accessories",
    "Cosmetics",
    "Computers & Electronics",
    "Consulting Services",
    "Digital Services",
    "Education & Training",
    "Entertainment",
    "Event Planning & Services",
    "Fitness & Sports",
    "Food & Beverages",
    "Furniture & Home Decor",
    "Garden & Outdoor",
    "Health & Wellness",
    "Home Improvement",
    "Industrial & Scientific",
    "Jewelry & Watches",
    "Legal Services",
    "Marketing & Advertising",
    "Medical Services",
    "Music & Instruments",
    "Office Supplies",
    "Pet Supplies",
    "Photography & Videography",
    "Real Estate",
    "Software & Apps",
    "Toys & Games",
    "Travel & Tourism",
    "Vehicle Sales & Rentals"
];

// Export the categories array for use in other files
export default categories;
